// @flow

export const baseUrl = "mein-remindme";
const DashboardRoute: string = `/${baseUrl}`;

export default DashboardRoute;
